<template>
  <div class="productListing">
    <section class="detail_content" style="padding-top:15px" :class="{
        paddingTop: !couponResponse,
        paddingMore: couponResponse && couponResponse.discountedAmount
      }">
      <div class="all_shop_listing">
        <!-- <div style="position: sticky; z-index: 9; background: #fff">
          <div class="shop-search">
            <span class="close-icon" @click="clearSearchText()">
              <CloseIcon />
            </span>
            <input
              type="text"
              class="input-searchbg"
              placeholder="Search by keywords"
              v-on:keyup="searchProducts($event)"
              v-model="searchTerm"
            />
            <span
              class="search-icon"
              @click="goToSearchResult()"
              :class="{ visibilityHidden: !searchTerm.length }"
            >
              <i class="material-icons">search</i>
            </span>
          </div>
        </div> -->

        <ul class="local_shop_list" :style="[
                            couponResponse && couponResponse.discountedAmount
                            ? { marginTop: '0' }
                            : { marginTop: '0' },
                        ]">
            <div class="shop-count-row flx" v-if="shopCount !=null">
                <h3 class="shop-count" >
                    Total Shops : {{ shopCount }}
                </h3>
                <p @click="getOnlineShops()"><span class="design-checkbox" :class="{'active':isShopOnline}"></span> Online Shops</p>
            </div>
          <li
            class="category-shops"
            v-for="(shops, index) in shopsList"
            :key="index"
          >
            <div class="category-name" v-if="shops.categoryName && shops.sellerShopDTOs.length > 0">
              <img :src="shops.categoryLogo" />
              <h3>{{ shops.categoryName }}</h3>
            </div>
            <div class="cat-shop-list">
              <div
                class="shop-card"
                v-for="(shopCard, index) in shops.sellerShopDTOs"
                :key="index"
              >
                <div class="order-card">
                  <label class="product-details">
                    <span class="product-img"
                      ><img :src="shopCard.shopImage" alt="product-image"
                    /></span>
                    <div class="product-info">
                     <div class="product-title">
                        <h4 class="flx" style="    justify-content: end;    align-items: flex-start;">{{ shopCard.shopName }} <span style="width: 70px;    display: inline-block; padding: 0;" class="status-text flx" v-if="shopCard.verifiedStatus === 'VERIFIED'"><img src="../../assets/images/mVerified.png" alt="loader" /></span>
            <span style="background:#ff9933" class="status-text flx" v-else> <span class="material-icons" style="font-size: 17px;">schedule</span>&nbsp;Pending</span> </h4>
                        <span class="is-verified" v-if="shopCard.isApproved"><img src="../../assets/images/icons/verified-icon.png" alt="loader" /></span>
                      </div>
                      <div class="star-rating" v-if="shopCard.averageRating">
                        <star-rating
                          :read-only="true"
                          :increment="0.01"
                          :starSize="15"
                          active-color="#138808"
                          :rating="Number(shopCard.averageRating)"
                          :show-rating="false"
                        ></star-rating>
                      </div>
                      <p class="date">{{ shopCard.shopAddress }}</p>
                      <p class="date" v-if="shopCard.shopDistance">
                        <span class="material-icons" style="font-size: 1.25em"
                          >location_on</span
                        >
                        {{ Number(shopCard.shopDistance).toFixed(2) }} Km
                      </p>
                    </div></label
                  >
                  <div v-if="selectShopCategory==='OWNSHOP'" class="note-info">
                      <p v-if="['UNVERIFIED'].includes(shopCard.documentStatus)" class="note" style="background:#fff4e5"><span style="color:orange;font-weight:600">* {{$t('underVerificationMsg')}}</span>
                      </p>
                      <p v-else-if="['VERIFIED'].includes(shopCard.documentStatus)"></p>
                      <p v-else-if="['REJECTED'].includes(shopCard.documentStatus)" class="note"><span  style="color:#e02020;font-weight:600">{{$t('rejectedDocMsg')}}</span>
                      <span class="upload-btn" @click="goToVerifyDocument(shopCard.shopId, shopCard.cloudShop, shopCard.mall91PhysicalShop)">{{$t('upload')}}</span>
                      </p>
                      <p v-else class="note"><span  style="color:#e02020;font-weight:600">* {{$t('notAddedMsg')}}</span>
                      <span class="upload-btn" @click="goToVerifyDocument(shopCard.shopId, shopCard.cloudShop, shopCard.mall91PhysicalShop)">{{$t('upload')}}</span></p>
                      </div>
                      <span
                  class="material-icons more_optn"
                  @click="openDialogue(index)"
                  v-if="selectShopCategory==='OWNSHOP'"
                  >more_vert</span
                >
                <div class="openDialogue" v-if="isShow === index">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 23 23"
                    @click="isShow = !isShow"
                    class='close-icon'
                  >
                    <path
                      fill="#CDCDCD"
                      fill-rule="nonzero"
                      d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                      opacity=".675"
                    />
                  </svg>
                  <span @click="openDeleteShop(index)" class="flx"><DeleteIcon />{{$t('deleteShop')}}</span>
                  </div>
                  <div class="customModal" v-if="isDeleteBox === index">
                    <div class="modal_dialog Cod" style="padding:0">
                      <div class="modal_content" style="padding:15px">
                        <div class="modal_body padding0">
                          <p>{{ $t('doYouReallyWantToRemoveShop') }}</p>
                        </div>
                      </div>
                      <div class="modal_footer cod">
                        <button
                          type="button"
                          class="order_btn cancel"
                          @click="isDeleteBox = !isDeleteBox"
                        >
                          {{ $t('no') }}
                        </button>
                        <button
                          type="button"
                          class="order_btn order-now"
                          @click="deleteShop(shopCard.shopId, index)"
                        >
                          {{ $t('yes') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="action-button">
                      <div v-if="selectShopCategory==='OWNSHOP'" style="    width: 100%;">
                    <button
                      type="button"
                      class="blank-button"
                      @click="seeShop(shopCard.shopId)"
                      :style="[
                            shopCard.showOnline
                            ? { width: '50%' }
                            : { width: '50%' },
                        ]"
                    >
                      दूकान देखें
                    </button>
                    <button
                      type="button"
                      class="fill-button"
                      @click="viewShop(shopCard.shopId)"
                      v-if="selectShopCategory==='OWNSHOP'"
                    >
                      मैनेज दुकान
                    </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <infinite-loading
          @infinite="getShopsListing"
          spinner="circles"
          :identifier="resetIdentifier"
          :class="{ visibilityHidden: noResultFound }"
          v-if="isShopList"
        >
          <template slot="no-more">{{ $t("noMoreRecord") }}</template>
        </infinite-loading>
        <infinite-loading
          @infinite="getSearchShopListing"
          spinner="circles"
          :identifier="resetIdentifier"
          :class="{ visibilityHidden: noResultFound }"
          v-if="isSearchShopList"
        >
          <template slot="no-more">{{ $t("noMoreRecord") }}</template>
        </infinite-loading>
      </div>
      <div class="no-product" v-if="noResultFound" style="    padding-top: 50px;">
        <p class="no-data-found">Please create your own Shop</p>
      </div>
    </section>
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <!-- <button @click="helpOnWhatsapp($event)" class="create-shop whatsapp" style="bottom: 125px;background: #4caf50;"><GreenWhatsappIcon />Help on Whatsapp</button> -->
    <!-- <button @click="createShop($event)" class="create-shop"><ShopIcon />Create New Shop</button> -->
    <button @click="createShop($event)" class="create-shop">+ Create Shop</button>
  </div>
</template>

<script>
import NoDataFound from "../../components/Common/NoDataFound";
import { mapGetters } from "vuex";
import CopyIcon from "@/components/Icons/CopyIcon";
import SearchIcon from "../../components/Icons/SearchIcon";
import GreenWhatsappIcon from "../../components/Icons/GreenWhatsappIcon"
import DeleteIcon from "../../components/Icons/DeleteIcon"
import CloseIcon from "../../components/Icons/CloseIcon";
import types from "../../store/types";
import constant from "../../utils/constant";
import ApiCaller from "../../utils/apicaller";
import Vue from "vue";
import InfiniteLoading from "vue-infinite-loading";
import ShopIcon from "@/components/Icons/ShopIcon";
import StarRating from "vue-star-rating";
Vue.use(InfiniteLoading);
export default {
  name: "MyLocalShops",
  components: {
    InfiniteLoading,
    NoDataFound,
    CopyIcon,
    SearchIcon,
    CloseIcon,
    ShopIcon,
    StarRating,
    GreenWhatsappIcon,
    DeleteIcon
  },
  data() {
    return {
      searchTerm: "",
      shopsList: [],
      pageIndex: 0,
      selectShopCategory: "",
      shopCategoryList: [],
      resetIdentifier: +new Date(),
      pageIndex: 0,
      shopCatId: null,
      shopCount: null,
      noResultFound: false,
      isShopList: true,
      isSearchShopList: false,
      isShopOnline: true,
      loading: false,
      isShow: false,
      isDeleteBox: false,
      snackbarShow: false
    };
  },
  computed: {
    ...mapGetters(["couponResponse"]),
  },
  methods: {
     openDialogue(index) {
      this.isShow = index;
    },
    openDeleteShop(index) {
      this.isShow = false;
      this.isDeleteBox = index;
    },
    deleteShop(id, index) {
      this.loading = true;
      this.isShow = false;
      this.isDeleteBox = false;
      ApiCaller(
        constant.SHOP_SERVICE_URL,
        'delete-shop/' + id,
        'DELETE'
      ).then((data) => {
        this.loading = false;
        let disableItem = document.querySelectorAll('.order-card');
          disableItem[index].classList.add('disable');       
        setTimeout(()=>{
         this.shopsList[0].sellerShopDTOs = this.shopsList[0].sellerShopDTOs.filter(it=>it.shopId!=id)
        },500)
        this.snackbarShow = !this.snackbarShow
        setTimeout(()=> {
          this.snackbarShow = !this.snackbarShow;        
        }, 3000);
      }).catch(err =>{
        this.loading = false;
      })
    },
    helpOnWhatsapp(event){
       event.stopPropagation();
      try {
        JSBridgePlugin.msgToWhatsApp();
      } catch (err) {
        console.log(err);
      }
    },
    goToVerifyDocument(shopId, cloudShopValue, mallPhysicalShopValue){
       if(cloudShopValue || mallPhysicalShopValue){
        this.$router.push('/manage-shops?shopid=' + shopId + '&openTab=myProduct&CLOUDSHOP=YESverificationShop=verify')
      }else{
        this.$router.push('/manage-shops?shopid=' + shopId + '&openTab=myProduct&verificationShop=verify')
      }
    },
    createShop(event){
        event.stopPropagation();
      this.$router.push('/create-shop')
    },
    async sendMessages(id) {
      await ApiCaller(
        constant.SELLER_DETAIL_URL,
        `channel-shop-details/${id}`,
        "get"
      ).then((data) => {
        const channelData = JSON.stringify(data.data);
        try {
          _openShop.openShop = (res) => {
            this.loading = false;
            console.log(res);
          };
          JSBridgePlugin.openShop(channelData);
        } catch (err) {
          this.loading = false;
          console.log(channelData);
        }
      });
    },
    async rateToShop(id, shopName) {
      this.$router.push('/shop-rating/'+id + '?shopName=' + shopName)
    }, 
    viewShop(sellID) {
      this.$store.commit("saveData", {
        catalogueList: [],
        catalogueIndex: 0,
        type: "my_catalogue",
      });
      this.$store.commit("saveData", {
        mostSellingItemList: [],
        mostSellingPageIndex: 0,
        type: "most_selling_item",
      });
      this.$store.commit(types.CATEGORY_PRODUCT, []);
      this.$store.commit(types.NEW_COLLECTION, []);
      this.$store.commit(types.MAIN_SLIDER, []);
      if (this.selectShopCategory === 'OWNSHOP') {
         this.$cookie.set("orderStatus", 'my_localshop');
        this.$router.push("/manage-shops?shopid=" + sellID );
      } else {
        this.$router.push("/daily-needs?shopid=" + sellID);
      }
    },
    seeShop(sellID){
      this.$store.commit("saveData", {
        catalogueList: [],
        catalogueIndex: 0,
        type: "my_catalogue",
      });
      this.$store.commit("saveData", {
        mostSellingItemList: [],
        mostSellingPageIndex: 0,
        type: "most_selling_item",
      });
      this.$store.commit(types.CATEGORY_PRODUCT, []);
      this.$store.commit(types.NEW_COLLECTION, []);
      this.$store.commit(types.MAIN_SLIDER, []);
      this.$router.push("/daily-needs?shopid=" + sellID);
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    selectShopCateogryOption(value, id) {
        this.isShopList = true;
        this.isSearchShopList = false
        this.searchTerm = ""
        if (value != this.selectShopCategory) {
            this.selectShopCategory = value;
            this.shopCatId = id;
            this.pageIndex = 0;
            this.shopsList = [];
            this.resetIdentifier += 1;
        }
    },
    searchProducts(event) {
      if (
        event != null &&
        typeof event.keyCode != "undefined" &&
        event.keyCode == 13
      ) {
        if (event.target.value.length > 2) {
            this.isShopList = false;
            this.isSearchShopList = true
            this.searchTerm = event.target.value;
            // this.pageIndex = 0;
            // this.shopsList = [];          
            // this.getSearchShopListing();
        }
      } else {
        if (event.target.value.length > 2) {
            this.isShopList = false;
            this.isSearchShopList = true
            this.searchTerm = event.target.value;
            // this.pageIndex = 0;
            // this.shopsList = [];
            // this.getSearchShopListing();
        }
      }
    },
    clearSearchText() {
        this.isShopList = true;
        this.isSearchShopList = false
        this.searchTerm = "";
        this.pageIndex = 0;
        this.shopsList = [];
        // this.selectShopCategory = "NEARBY";
        this.getShopsListing();
    },
    goToSearchResult() {
        if (this.searchTerm.length > 2){
            this.isShopList = false;
            this.isSearchShopList = true
            this.pageIndex = 0;
            this.shopsList = [];
            this.getSearchShopListing();
        }
        
    },
    getShopCategory() {
      ApiCaller(constant.SELLER_DETAIL_URL, "shop-category", "get").then(
        (data) => {
          this.shopCategoryList = data.data;
        }
      );
    },
    getOnlineShops(){
        this.loading = true;
        this.isShopOnline = !this.isShopOnline;
        this.isShopList = true;
        this.isSearchShopList = false
        this.pageIndex = 0;
        this.shopsList = [];
        this.resetIdentifier += 1;
        // this.selectShopCategory = "NEARBY";
        // this.getShopsListing();
    },
    getSearchShopListing($state) {
      ApiCaller(
        constant.SELLER_DETAIL_URL,
        `shop-search/${this.pageIndex}?shopName=${this.searchTerm}`,
        "get"
      ).then((data) => {
        this.shopCount = data.data.shopCount;
        if (
          data &&
          data.data &&
          data.data.sellerShopCategoryDTOs &&
          data.data.sellerShopCategoryDTOs.length > 0 &&
          data.data.sellerShopCategoryDTOs[0].sellerShopDTOs.length > 0
        ) {
          this.shopsList.push(...data.data.sellerShopCategoryDTOs);
          this.pageIndex = this.pageIndex + 1;
          this.noResultFound = false;
          $state && $state.loaded();
        } else if (
          (this.shopsList.length === 0 &&
            data &&
            data.data &&
            data.data.sellerShopCategoryDTOs &&
            data.data.sellerShopCategoryDTOs.length == 0) ||
          (this.shopsList.length === 0 &&
            data &&
            data.data &&
            data.data.sellerShopCategoryDTOs &&
            data.data.sellerShopCategoryDTOs.length > 0 &&
            data.data.sellerShopCategoryDTOs[0].sellerShopDTOs.length == 0)
        ) {
          this.noResultFound = true;
        } else {
          $state && $state.complete();
        }
      });
    },
    getShopsListing($state) {
      let payloadObject;
      payloadObject = `${'OWNSHOP'}/${this.pageIndex}?onlineShop=${this.isShopOnline}`;
      ApiCaller(
        constant.SELLER_DETAIL_URL,
        `get-seller-shop/${payloadObject}`,
        "get"
      ).then((data) => {
          this.loading = false
        if (this.pageIndex === 0) this.shopCount = data.data.shopCount;
        if (
          data &&
          data.data &&
          data.data.sellerShopCategoryDTOs &&
          data.data.sellerShopCategoryDTOs.length > 0 &&
          data.data.sellerShopCategoryDTOs[0].sellerShopDTOs.length > 0
        ) {
          this.shopsList.push(...data.data.sellerShopCategoryDTOs);
          this.pageIndex = this.pageIndex + 1;
          this.noResultFound = false;
          $state && $state.loaded();
        } else if (
          (this.shopsList.length === 0 &&
            data &&
            data.data &&
            data.data.sellerShopCategoryDTOs &&
            data.data.sellerShopCategoryDTOs.length == 0) ||
          (this.shopsList.length === 0 &&
            data &&
            data.data &&
            data.data.sellerShopCategoryDTOs &&
            data.data.sellerShopCategoryDTOs.length > 0 &&
            data.data.sellerShopCategoryDTOs[0].sellerShopDTOs.length == 0)
        ) {
          this.noResultFound = true;
        } else {
          $state && $state.complete();
        }
      }).catch(err=>{
          this.loading = false;
          $state && $state.complete();
      })
    },
  },
  mounted() {
    this.getShopCategory();
    if(this.$route.query.createdShopRedirect){
      this.selectShopCategory = 'OWNSHOP'
    }else{
      this.selectShopCategory = "OWNSHOP"
    }
  },
};
</script>
<style lang="scss" scoped>
.cat-shop-list{
  padding-bottom: 50px !important;
}
.create-shop{
background: green;
    font-size: 14px;
    border-radius: 5px;
}
.order-card{
  position: relative;
  .more_optn{
                position: absolute;
                top: 8px;
                right: 8px;
              }
}
.openDialogue {
          position: absolute;
          width: 40%;
          z-index: 9;
          background: #fff;
          right: 0;
          box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
          top: 0;
          bottom: auto;
          left: auto;
          padding: 16px;
          border-radius: 10px;

          .close-icon {
            position: absolute;
            right: 8px;
            top: 8px;
          }

          span {
                font-size: 0.875em;
                padding: 8px 8px 8px 0;
                white-space: nowrap;
                color: #007aff ;
                align-items: center;
                font-weight: 600;
          }
        }
.status-text{
  border-radius: 5px;
  color: #fff;
  padding: 4px 8px;
  margin-left: 8px;
  font-size: 0.875em;
}
.star-rating {
  // padding-left: 16px;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  span {
    color: rgb(0, 145, 255);
    font-size: 0.75em;
    padding-left: 8px;
    // font-weight: 500;
  }
}
.no-data-found {
  text-align: center;
  font-size: 0.938em;
  font-weight: normal;
  border: 1px solid;
  width: max-content;
  margin: 0 auto;
  padding: 4px 55px;
  border-radius: 25px;
  background: #eee;
}
.productListing .detail_content .main_customHeading.topZero {
  top: 0;
}
.productListing .detail_content .main_customHeading.topHeight {
  top: 44px;
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
p.product-name {
  font-size: 0.87em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  white-space: nowrap;
  margin-bottom: 5px;
}
.sortOption {
  color: #0091ff;
}
.noFilter {
  padding-top: 35px;
}
.paddingTop,
.productListing .detail_content.paddingTop {
  padding-top: 0;
}
.productListing .detail_content.paddingMore {
  padding-top: 5px;
}
.topLess {
  top: 0;
}
.topMore {
  top: 45px;
}
</style>